"use client";

import { Flex } from "@chakra-ui/react";
import { FiArrowLeft } from "react-icons/fi";
import { EmptyState } from "@/components/feedback";
import { Button, Link, NavLink, Text } from "@/components/ui";
import { PageTypeGlobal } from "@/lib/types";
import { useThemeTokens } from "@/lib/theme/tokens";

interface LocationPublicPageErrorProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export const LocationPublicPageError = ({
  onRetry,
  isRetrying = false,
}: LocationPublicPageErrorProps) => {
  const theme = useThemeTokens();

  return (
    <EmptyState
      title="Couldn't load this location"
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            Something went wrong while fetching this location. Please try again.
          </Text>
          <Flex gap={3} wrap="wrap" justify="center">
            <Button
              variant="primary"
              size="sm"
              data-testid="location-public-retry-button"
              onClick={onRetry}
              isLoading={isRetrying}
              isDisabled={isRetrying}
            >
              Try again
            </Button>
            <Link
              as={NavLink}
              fontSize="sm"
              fontWeight="500"
              color={theme.accent.primary}
              href={PageTypeGlobal.Classes}
              display="inline-flex"
              alignItems="center"
              gap={1}
            >
              <FiArrowLeft />
              Back to classes
            </Link>
          </Flex>
        </Flex>
      }
    />
  );
};

export const LocationPublicPageNotFound = () => {
  const theme = useThemeTokens();

  return (
    <EmptyState
      title="Location not found"
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            This location could not be found or is no longer available.
          </Text>
          <Link
            as={NavLink}
            fontSize="sm"
            fontWeight="500"
            color={theme.accent.primary}
            href={PageTypeGlobal.Classes}
            display="inline-flex"
            alignItems="center"
            gap={1}
          >
            <FiArrowLeft />
            Back to classes
          </Link>
        </Flex>
      }
    />
  );
};

export const LocationPublicPageUnavailable = () => {
  const theme = useThemeTokens();

  return (
    <EmptyState
      title="Location unavailable"
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            This location isn&apos;t available right now.
          </Text>
          <Link
            as={NavLink}
            fontSize="sm"
            fontWeight="500"
            color={theme.accent.primary}
            href={PageTypeGlobal.Classes}
            display="inline-flex"
            alignItems="center"
            gap={1}
          >
            <FiArrowLeft />
            Back to classes
          </Link>
        </Flex>
      }
    />
  );
};
